import { Card, Icon, Popup } from "semantic-ui-react";
import { assetTypeToPlaceholderIcon, formatInformationLength } from "services/common";
import AssetCardInformation from "components/AssetCardInformation/AssetCardInformation";
import AssetImage from "components/AssetImage/AssetImage";

const OldAssetsSelectionCard = ({ t, asset, handleSetClickedAssetId }) => {
  return (
    <Card
      color={asset.status === "QC_FAILED" ? "red" : "green"}
      key={asset.id}
      label={{ as: "a", corner: "left", icon: "heart" }}
      className={
        asset.isSelected
          ? "asset selected"
          : asset.isErrored
          ? "asset errored"
          : asset.isDownloaded
          ? "asset downloaded"
          : "asset"
      }
      onClick={() => handleSetClickedAssetId(asset.id)}
    >
      <div aria-hidden="true" className="asset-properties" index={asset.id}>
        <Card.Content>
          <div
            style={{
              width: "100%",
              height: "200px",
              overflow: "hidden",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AssetImage asset={asset} />
          </div>
          <Card.Header style={{ marginTop: "1rem", wordBreak: "break-all" }}>
            <div className="material-type">
              {assetTypeToPlaceholderIcon(asset.type, "large")}
              <Popup
                content={asset.name}
                position="top center"
                on="hover"
                disabled={!asset.name || asset.name.length <= 20}
                trigger={<span>{formatInformationLength(asset.name, 20)}</span>}
              />
            </div>
          </Card.Header>
          <AssetCardInformation asset={asset} maxLength={20} t={t} />
        </Card.Content>
        <Card.Content extra>
          <div key={asset.id} className="asset-title-container">
            <div className={`status ${asset.status.toLowerCase()}`} key={asset.id}>
              {asset.status.toUpperCase().indexOf("QC") > -1 ? (
                asset.status.toUpperCase().split("_")[1] !== "FAILED" ? (
                  <div>
                    <Icon color="green" name="check" />
                    {asset.status.toUpperCase().split("_")[1]}
                  </div>
                ) : (
                  <div>
                    <Icon color="red" name="x" />
                    {asset.status.toUpperCase().split("_")[1]}
                  </div>
                )
              ) : (
                asset.status.toUpperCase()
              )}
            </div>
          </div>
        </Card.Content>
      </div>
    </Card>
  );
};

export default OldAssetsSelectionCard;
